export default __webpack_public_path__ + "static/media/albufissaLogo.3bd288cf.png";